import clsx from 'clsx'

import { COFFEE_MATCH_STEP } from 'src/selectors'

import styles from './Steps.module.scss'

export interface StepsProps {
  steps: number
  currentIndex: number
}

export const Steps = ({ steps, currentIndex }: StepsProps) => (
  <div className={styles.stepper}>
    <div className={styles.steps}>
      {[...Array(steps).keys()].map((step) => (
        <div
          key={`step-${step}`}
          className={clsx(styles.step, step <= currentIndex && styles.active)}
          data-cy={COFFEE_MATCH_STEP}
        >
          <span className={styles.badge}>{step + 1}</span>
        </div>
      ))}
    </div>
  </div>
)
